;(function() {
/* @ngInject */
function ReadyMadeObjednaneController(CompletedOrderService, $window, $filter, Helpers) {
    let vm = this;
    let server = CompletedOrderService;

    vm.showLoading = false;

    server.getCompletedOrderData().then(onPaymentInfoLoad);

    let dataLayerStorage = $window.localStorage.getItem('dataLayer');
    $window.localStorage.removeItem('dataLayer');
    var dataLayer = $window.dataLayer = $window.dataLayer || [];
    if (dataLayerStorage)
        dataLayer.push(JSON.parse(dataLayerStorage));

    function onPaymentInfoLoad(payment) {
        if(payment) {
            vm.orderId = payment.orderId;
        } else {
            $window.location = "krok1";
        }
    }
}

angular.module("firmaren")
    .controller("ReadyMadeObjednaneController", ReadyMadeObjednaneController);
}());
